// extracted by mini-css-extract-plugin
export default {"clear":"ClearIndicatorPart_clear__50A+R","icon":"ClearIndicatorPart_icon__4kZ2S"};